angular.module('unica_location.location_controllers', [])

.controller('LocationBasicController',
	function(
		$rootScope, $scope,
		LocationListService
	) {

	$scope.forms = {};

	$scope.locationData = {
		name: '',
		address: '',
		latitude: '',
		longitude: '',
		route_description: ''
	};

	$scope.marker = null;

	$scope.map = {
		center: { latitude: 41.9099856, longitude: 12.3955726 },
		options: {
			streetViewControl: false,
			fullscreenControl: false,
			mapTypeControl: false
		},
		zoom: 7,
		events: {
			click: function (map, eventName, originalEventArgs) {
				var e = originalEventArgs[0];
				$scope.geocodePosition(e);
				var lat = e.latLng.lat(),
					lng = e.latLng.lng();
				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: lat,
						longitude: lng
					}
				};
				$scope.map.center = { latitude: lat, longitude: lng };
				$scope.$apply();
			}
		}
	};

	$scope.geocoding = false;
	$scope.geocoder = new google.maps.Geocoder();
	$scope.geocodePosition = function(event) {

		$scope.locationData.latitude = event.latLng.lat();
		$scope.locationData.longitude = event.latLng.lng();

		$scope.geocoding = true;
		$scope.geocoder.geocode({
			latLng: event.latLng
		}, function(responses) {

			$scope.geocoding = false;
			if (responses && responses.length > 0) {
				$scope.locationData.address = responses[0].formatted_address;
			}

			$scope.$apply();
		});
	};

	$scope.lookupLocation = function() {
		$scope.geocoder.geocode({
			address: $scope.locationData.address
		}, function(responses) {
			if (responses && responses.length > 0) {
				$scope.locationData.latitude  = responses[0].geometry.location.lat();
				$scope.locationData.longitude = responses[0].geometry.location.lng();

				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: $scope.locationData.latitude,
						longitude: $scope.locationData.longitude
					}
				};

				$scope.map.center = { latitude: $scope.locationData.latitude, longitude: $scope.locationData.longitude };
				$scope.map.zoom   = 16;

				$scope.$apply();
			}
		});
	};

	$scope.getLocation = function(locationId) {
		$scope.showLoader();

		LocationListService
			.get(locationId)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.locationData = data;

					$scope.marker = {
						id: Date.now(),
						coords: {
							latitude: $scope.locationData.latitude,
							longitude: $scope.locationData.longitude
						}
					};
					$scope.map.center = { latitude: $scope.locationData.latitude, longitude: $scope.locationData.longitude };
					$scope.map.zoom = $scope.locationData.zoom;
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});